'use client';

import type { FC, PropsWithChildren } from 'react';
import { cx } from '../../utils/cx';
import type { BoxProps } from '../Box';
import { Box } from '../Box';
import styles from './ContextualPopupSection.module.css';

export interface ContextualPopupSectionProps extends BoxProps {}

export const ContextualPopupSection: FC<
  PropsWithChildren<ContextualPopupSectionProps>
> = ({ children, className, ...props }) => (
  <Box padding={16} {...props} className={cx(styles.root, className)}>
    {children}
  </Box>
);
